module.exports = __webpack_public_path__ + "img/arrow-right-disable.06f31812.svg";